/**
 * @hidden
 */
export function getDefaultSlots(component) {
    var defaultSlots = component.$slots.default;
    return (component.v3 && defaultSlots && typeof defaultSlots === 'function') ? defaultSlots() : defaultSlots;
}
